import Cookies from 'js-cookie';

const videoTriggers = [...document.querySelectorAll('.js-video-trigger')];

function checkWatched(video) {
  if (!video.dataset.cookieId) {
    return;
  }

  if (Cookies.get(`video-${video.dataset.cookieId}`)) {
    video.classList.add('is-viewed');
  }
}

function setWatched(e) {
  const video = e.target.closest('.js-video-item');

  if (!video.dataset.cookieId) {
    return;
  }

  video.classList.add('is-viewed');
  Cookies.set(`video-${video.dataset.cookieId}`, 'true', {
    expires: 365,
    path: '/',
  });
}

function init() {
  if (videoTriggers) {
    videoTriggers.forEach((videoTrigger) => {
      const video = videoTrigger.closest('.js-video-item');
      checkWatched(video);
      videoTrigger.addEventListener('click', setWatched);
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/default/video/video-item/mando-ui.video-item.js